// import { stringify as stringifyQs } from "qs";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";
import { ComboDetailsPageTab } from "./components/ComboDetails";
export const comboSection = "/combos/";

export const comboListPath = comboSection;

export enum ComboListUrlSortField {
  name = "name",
  total_price = "total_price",
  enable = "enable",
  last_change = "last_change",
  order_number = "order_number"
}

export type ComboListUrlSort = Sort<ComboListUrlSortField>;

export type ComboListUrlQueryParams = ActiveTab &
  ComboListUrlFilters &
  ComboListUrlSort &
  BulkAction &
  Dialog<ComboListUrlDialog> &
  Pagination;

export type ComboListUrlDialog = "enable" | "unenable" | TabActionDialog;
export const comboListUrl = (params?: ComboListUrlQueryParams) =>
  comboListPath + "?" + stringifyQs(params);

export enum ComboListUrlFiltersEnum {
  name = "name",
  products = "products",
  enable = "enable",
  query = "query"
}
export type ComboListUrlFilters = Filters<ComboListUrlFiltersEnum>;
export const comboAddPath = urlJoin(comboSection, "add");
export type ComboAddUrlQueryParams = Pagination;
export const comboAddUrl = (params?: ComboAddUrlQueryParams) =>
  comboAddPath + "?" + stringifyQs(params);
export type ComboUrlDialog = "unassign-product" | "remove" | "assign-product";
export const comboPath = (id: string) => urlJoin(comboSection, id);

export type ComboUrlQueryParams = BulkAction &
  Dialog<ComboUrlDialog> &
  ActiveTab<ComboDetailsPageTab> &
  Pagination;
export const comboUrl = (id: string, params?: ComboUrlQueryParams) =>
  comboPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
